import React from 'react';
import RocketList from '../views/RocketList';

const Rockets = () => (
  <main id="rockets">
    <RocketList />
  </main>
);

export default Rockets;
